import React from "react";
import { Stack } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";
import { SkeletonCard } from "./AIAnswer.styles";

export const AIAnswerSkeleton: React.FC = () => (
  <SkeletonCard>
    <Stack space="medium">
      <Stack space="xxsmall">
        <Skeleton variant="text" width="30%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="100%" />
      </Stack>
      <Stack space="xxsmall">
        <Skeleton variant="text" width="60%" />
        <Skeleton variant="text" width="30%" />
        <Skeleton variant="text" width="100%" />
        <Skeleton variant="text" width="60%" />
      </Stack>
    </Stack>
  </SkeletonCard>
);
